import { API_ENDPOINTS } from '@/constants';
import type { GetQuickScriptsResponse } from '@/types/quickScripts';
import type { ApiBuilder } from './types';

/**
 * Quick Scripts API using RTK Query.
 * Provides hooks for fetching quick scripts.
 */
export const quickScriptsApi = (builder: ApiBuilder) => ({
  getQuickScripts: builder.query<GetQuickScriptsResponse, void>({
    query: () => ({
      url: API_ENDPOINTS.QUICK_SCRIPTS.LIST,
      method: 'GET',
    }),
    providesTags: ['QuickScripts'],
  }),
});
